import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import IngresarSolicitudInforme from './ingresar-solicitud-informe.js'
import GrillaSolicitudes from './grillaSolicitudes'
import {serviceGetSolicitudes} from '../../api/api-solicitar-informe-profesional-ext.js';
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'

const SolicitarInforme = ({ showModal, setShowModal, idCaso, idImplicado, idOrgCaso}) => {

    const [cfg_form, setCfg_form] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const [solicitudes, setSolicitudes] = useState([]);

    useEffect(() => {
        if (showModal) getSolicitudes();
    }, [showModal])

    const getSolicitudes = async () => {
        console.log("getSolicitudes....")
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso })).toString('base64');
        const response = await serviceGetSolicitudes(query);
        setSolicitudes(response);
        setLoading(false);
    }

    useEffect(() => {     
    
        dispatch(obtenerDatosLlaves({"idCaso":idCaso, "idImplicado":idImplicado, "idOrgCaso":idOrgCaso}));
        
    }, [dispatch])

    return (
        <Fragment>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <LoadingComponent show={loading}/>
                <IngresarSolicitudInforme 
                    showModal= {showModal} 
                    setShowModal={setShowModal} 
                    solicitudes={solicitudes}
                    getSolicitudes={getSolicitudes}
                />
                <GrillaSolicitudes 
                    cfg_form ={cfg_form} 
                    solicitudes={solicitudes}
                />
            </Modal>            
        </Fragment>
    )
}

export default SolicitarInforme